module.exports = __webpack_public_path__ + "img/illustration_milk_tea.726c7168.png";